import src from "IMAGE";
export default { src, width: 69, height: 69, blurWidth: 0, blurHeight: 0};
